import React, {useEffect, useRef} from 'react';
import {Handle, Position} from "react-flow-renderer";
import {logDOM} from "@testing-library/react";

const Reply = ({data,id,id1,id2}) => {

    const textArr = useRef()

    function auto_grow(element) {

        element.target.style.height = "5px";
        element.target.style.height = (element.target.scrollHeight)+"px";
    }

    const onChange = (event)=>{
        if((data.replys[id] !== undefined) &&  (data.replys[id].text !== undefined))
            data.replys[id].text = event.target.value
    }

    useEffect(()=>{
        //
        textArr.current.style.height = "5px";
        textArr.current.style.height = (textArr.current.scrollHeight)+"px";
    },[])

    return (
        <div className="reply">
            <Handle onMouseEnter={()=>{data.mouseOverHandle(true)}} onMouseLeave={()=>{data.mouseOverHandle(false)}}
                    className="InRely" type="target" position={Position.Left} id={id1}  />
            <textarea
                placeholder="Reply"
                ref={textArr} defaultValue={(data.replys[id] !== undefined) ? data.replys[id].text : ""} onInput={auto_grow} onChange={onChange}
                style={{width:"100%", overflowY:"auto",
                    overflowX:"hidden",
                    resize:"none",
                    background:"transparent", color:"white",
                    outline:"none", border:"0", margin:"0",
                    height:"19px", maxHeight:"100px"
                }}></textarea>
            <Handle className="OutReply" type="source" position={Position.Right} id={id2} />
        </div>
    );
};

export default Reply;